import Icon from '@/core/icon.js';

function Loading({ color = 'text-purple' }) {
  return (
    <div className="flex items-center justify-center w-full h-5">
      <Icon name="loader" className={`w-5 h-5 animate-spin ${color}`} />
    </div>
  );
}

export default Loading;
